import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("stat-badge")
export class StatBadge extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      align-items: center;
      gap: var(--sds-size-space-300);
      padding: var(--sds-size-space-200) var(--sds-size-space-600);
      background-color: var(--sds-color-border-default-default);
      border-radius: var(--sds-size-radius-400);
      font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-title);
      color: var(--sds-color-text-default-secondary);
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      .label {
        display: none;
      }
    }
  `;

  @property({ type: Number })
  count = 0;

  override render() {
    return html`
      <slot name="icon"></slot>
      <span class="label"><slot></slot></span>
      <span>${this.count}</span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "stat-badge": StatBadge;
  }
}
